import { TechnicalDocAnswer } from '../interfaces/technical-doc.interface';

export function formatTechnicalDocAsText(tech: TechnicalDocAnswer): string {
  const lines: string[] = [];
  const hr = '-'.repeat(80);

  lines.push('='.repeat(80));
  lines.push('ENTENDIMENTO TÉCNICO');
  lines.push('='.repeat(80));
  lines.push('');

  if (tech.executive_summary) {
    lines.push('RESUMO EXECUTIVO');
    lines.push(hr);
    if (tech.executive_summary.objective) {
      lines.push('Objetivo:');
      lines.push(tech.executive_summary.objective);
      lines.push('');
    }
    if (tech.executive_summary.impacts?.length) {
      lines.push('Impactos:');
      tech.executive_summary.impacts.forEach(impact => lines.push(`  • ${impact}`));
      lines.push('');
    }
  }

  if (tech.files?.length) {
    lines.push('DETALHAMENTO POR ARQUIVO');
    lines.push(hr);
    tech.files.forEach((file, index) => {
      if (index > 0) { lines.push(''); }
      lines.push(`Arquivo ${index + 1}: ${file.file || '-'}`);
      lines.push(`  Linhas: ${file.lines || '-'}`);
      lines.push(`  Papel: ${file.role || '-'}`);
      lines.push(`  Mudanças: ${file.changes || '-'}`);
      lines.push(`  Propósito: ${file.purpose || '-'}`);
      if (file.dependencies?.length) {
        lines.push('  Dependências:');
        file.dependencies.forEach(dep => lines.push(`    • ${dep}`));
      }
    });
    lines.push('');
  }

  if (tech.quality_risks) {
    lines.push('QUALIDADE E RISCOS');
    lines.push(hr);
    if (tech.quality_risks.best_practices?.length) {
      lines.push('Boas Práticas:');
      tech.quality_risks.best_practices.forEach(p => lines.push(`  • ${p}`));
      lines.push('');
    }
    if (tech.quality_risks.risks?.length) {
      lines.push('Riscos:');
      tech.quality_risks.risks.forEach(r => lines.push(`  • ${r}`));
      lines.push('');
    }
    if (tech.quality_risks.suggestions?.length) {
      lines.push('Sugestões:');
      tech.quality_risks.suggestions.forEach(s => lines.push(`  • ${s}`));
      lines.push('');
    }
  }

  if (tech.tests_deploy) {
    lines.push('TESTES E DEPLOY');
    lines.push(hr);
    if (tech.tests_deploy.tests?.length) {
      lines.push('Testes:');
      tech.tests_deploy.tests.forEach(t => lines.push(`  • ${t}`));
      lines.push('');
    }
    if (tech.tests_deploy.deploy?.length) {
      lines.push('Deploy:');
      tech.tests_deploy.deploy.forEach(d => lines.push(`  • ${d}`));
      lines.push('');
    }
  }

  if (tech.tdn) {
    lines.push('TDN (TOTVS DEVELOPERS NETWORK)');
    lines.push(hr);
    if (tech.tdn.situation) {
      lines.push('Situação:');
      lines.push(tech.tdn.situation);
      lines.push('');
    }
    if (tech.tdn.solution) {
      lines.push('Solução:');
      lines.push(tech.tdn.solution);
      lines.push('');
    }
    if (tech.tdn.suggested_labels?.length) {
      lines.push('Labels Sugeridas:');
      tech.tdn.suggested_labels.forEach(label => lines.push(`  • ${label}`));
      lines.push('');
    }
    if (tech.tdn.related_docs?.length) {
      lines.push('Documentos Relacionados:');
      tech.tdn.related_docs.forEach(doc => lines.push(`  • ${doc}`));
      lines.push('');
    }
  }

  lines.push('='.repeat(80));
  return lines.join('\n');
}
